import React, { useState, useEffect } from 'react';
import Select from 'react-select';
import axios from 'axios';
import { Constants } from '../../../endPoints';

export default function Searchcategory({ setCategory }) {
  const [categories, setCategories] = useState([]);
  const [isCategoryLoading, setIsCategoryLoading] = useState(false);

  useEffect(() => {
    const fetchCategories = async () => {
      setIsCategoryLoading(true);
      try {
        const response = await axios.get(Constants.listCategory);
        if (response.data.status === 1) {
          setCategories(response.data.list);
        }
      } catch (error) {
        console.error('Error fetching categories:', error);
      } finally {
        setIsCategoryLoading(false);
      }
    };
    fetchCategories();
  }, []);

  const categoryOptions = categories.map((category) => ({
    value: category.id,
    label: category.name,
    ImageUrl: `${Constants.imageBaseURL}/${category.image}`,
  }));

  const formatOptionLabel = ({ label, ImageUrl }) => (
    <div style={{ display: 'flex', alignItems: 'center' }}>
      <img
        src={ImageUrl}
        alt={`${label} category`}
        style={{ width: 20, height: 15, marginRight: 10 }}
      />
      {label}
    </div>
  );

  const handleCategoryChange = (selectedOption) => {
    setCategory(selectedOption?.value || ''); // Update the parent state with the selected value
  };

  return (
    <Select
      options={categoryOptions}
      onChange={handleCategoryChange}
      formatOptionLabel={formatOptionLabel}
      placeholder="Select Category"
      isSearchable
      isLoading={isCategoryLoading}
    />
  );
}
